import { AdaptiveDialog } from '@/components/blocks/AdaptiveDialog';
import { useCookieDialogContext } from '@/components/blocks/DpCookieDialogRecommendation';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { EMPTY_FUNCTION } from '@/data/constants/marketing';
import { combineSX } from '@/utils/combineSX';
import { Box, SxProps, Theme, Typography } from '@mui/material';

export const DpCookieDialog: React.FC<React.PropsWithChildren> = ({ children }) => {
	const { isCookieDialogAccepted } = useCookieDialogContext();

	if (isCookieDialogAccepted) {
		return null;
	}

	return (
		<AdaptiveDialog open hideCloseButton onClose={EMPTY_FUNCTION}>
			{children}
		</AdaptiveDialog>
	);
};

export const DpCookieDialogTitle: React.FC<
	React.PropsWithChildren<{
		sx?: SxProps<Theme>;
	}>
> = ({ children, sx, ...props }) => (
	<Typography
		sx={combineSX([
			{
				fontSize: '24px',
				fontWeight: 800,
				color: '#2c2c2c',
				marginBottom: '10px',
				textAlign: 'center',
				textTransform: 'uppercase',
			},
			sx,
		])}
		{...props}
	>
		{children}
	</Typography>
);

export const DpCookieDialogDescription: React.FC<
	React.PropsWithChildren<{
		sx?: SxProps<Theme>;
	}>
> = ({ children, sx, ...props }) => (
	<Typography
		sx={combineSX([
			{
				fontSize: '14px',
				color: '#2c2c2c',
				textAlign: 'center',
			},
			sx,
		])}
		{...props}
	>
		{children}
	</Typography>
);

export const DpCookieDialogActions: React.FC<
	React.PropsWithChildren<{
		sx?: SxProps<Theme>;
	}>
> = ({ children, sx, ...props }) => (
	<Box
		sx={combineSX([
			{
				display: 'flex',
				flexDirection: 'column',
				marginTop: '20px',
				gap: '10px',
				marginBottom: {
					xs: '30px',
					sm: '0px',
				},
			},
			sx,
		])}
		{...props}
	>
		{children}
	</Box>
);

export const DpCookieDialogConfirm: React.FC<
	React.PropsWithChildren<{
		sx?: SxProps<Theme>;
	}>
> = ({ children, sx, ...props }) => {
	const { handleCookieDialogAccept } = useCookieDialogContext();

	return (
		<DpButton
			variant="primary"
			size="small"
			sx={combineSX([
				{
					alignSelf: 'center',
					width: { xs: '100%', sm: '50%' },
				},
				sx,
			])}
			onClick={handleCookieDialogAccept()}
			{...props}
		>
			{children}
		</DpButton>
	);
};

export const DpCookieDialogLink: React.FC<
	React.PropsWithChildren<{
		sx?: SxProps<Theme>;
	}>
> = ({ children, ...props }) => {
	const { handleCookieDialogAccept } = useCookieDialogContext();

	return (
		<DpButton
			variant="text"
			fullWidth
			onClick={handleCookieDialogAccept('/aviso-privacidad')}
			{...props}
		>
			{children}
		</DpButton>
	);
};
